export const basename = "/app";

